export const addOffering = async (
    API_URL: string,
    token: string,
    employerId: string,
    offeringId: string,
    autoIssue: boolean
) => {
    const response = await fetch(`${API_URL}/employers/${employerId}/card-offerings/${offeringId}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            autoIssueCard: autoIssue
        })
    })

    if(!response.ok) {
        throw new Error('Failed to add offering');
    }

    return { success: true, type: offeringId };

}